module.exports = __webpack_public_path__ + "static/Kostchtchie-72bdfea1a20787c17ce4900678a20fd0.jpeg";